export const filesTypes = {
  SET_UPLOAD_FILE: 'SET_UPLOAD_FILE',
  RESET_UPLOAD_FILE: 'RESET_UPLOAD_FILE',
  SET_UPLOAD_PROGRESS: 'SET_UPLOAD_PROGRESS',
  SUCCESS_UPLOAD_FILE: 'SUCCESS_UPLOAD_FILE',
  FAILURE_UPLOAD_FILE: 'FAILURE_UPLOAD_FILE',
  GET_EXHIBIT_UPLOAD_URL: 'GET_EXHIBIT_UPLOAD_URL',
  GET_FINAL_UPLOAD_URL: 'GET_FINAL_UPLOAD_URL',
  GET_PRODUCTION_UPLOAD_URL: 'GET_PRODUCTION_UPLOAD_URL',
  PRE_EXHIBIT_UPLOAD: 'PRE_EXHIBIT_UPLOAD',
  PRE_FINAL_UPLOAD: 'PRE_FINAL_UPLOAD',
  PRE_PRODUCTION_UPLOAD: 'PRE_PRODUCTION_UPLOAD',
  UPLOAD_FILES: 'UPLOAD_FILES',
  UPLOAD_SINGLE_FILE: 'UPLOAD_SINGLE_FILE',
  SET_UPLOAD_FILE_STATUS: 'SET_UPLOAD_FILE_STATUS',
  DOWNLOAD_FILES: 'DOWNLOAD_FILES',
  PREPRARE_DOWNLOAD: 'PREPRARE_DOWNLOAD',
};

export type FileProgress = {
  id: number;
  depositionId: string;
  file: any;
  progress: number;
  status: number | undefined;
};

export type FilePreUploadPayload = {
  depositionId: string;
  fileName: string;
  contentType: string;
  file: any;
  id: number;
  partNumber?: number;
};

export type FilePreDownloadPayload = {
  downloadUri: string;
  fileName: string;
};

export type IFileState = Readonly<{
  fileProgress: { [key: number]: FileProgress };
  isUploadDone: boolean;
}>;
